import { useState } from 'react';
import '../styles/components/forms.css';

const DISCOVERY_DEFAULTS = {
  1: { output_validation: false },
  2: { output_validation: true },
};

const AGE_DEFAULTS = {
  1: { skip_linkedin: true,  skip_website: false },
  2: { skip_linkedin: false, skip_website: false },
};

export default function AdvancedOptions({ flags, onChange, mode, level }) {
  const [open, setOpen] = useState(false);

  const defaults = mode === 'discovery' ? (DISCOVERY_DEFAULTS[level] || {}) : (AGE_DEFAULTS[level] || {});
  const effective = (key) => flags[key] != null ? flags[key] : defaults[key];

  const set = (key, value) => {
    const next = { ...flags, [key]: value };
    onChange(next);
  };

  const toggle = (key) => {
    const current = effective(key);
    set(key, current ? false : true);
  };

  const needsLinkedIn = mode === 'discovery'
    ? !!effective('output_validation')
    : (mode === 'age_estimation' && !effective('skip_linkedin'));

  return (
    <div>
      <button className="advanced-toggle" onClick={() => setOpen(!open)}>
        <span className={`advanced-toggle-chevron${open ? ' open' : ''}`}>&#9654;</span>
        Advanced Options
      </button>

      {open && (
        <div className="advanced-body">
          <div className="options-row">
            <div className="option-group">
              <div className="option-label">LinkedIn Engine</div>
              <select
                className="option-select"
                value={flags.linkedin_engine || 'apify'}
                onChange={(e) => set('linkedin_engine', e.target.value)}
                disabled={!needsLinkedIn}
              >
                <option value="apify">Apify</option>
                <option value="zenrows">ZenRows</option>
                <option value="scrapingdog">ScrapingDog</option>
              </select>
              {!needsLinkedIn && <div style={{ fontSize: 11, color: 'var(--text3)', fontStyle: 'italic', marginTop: 4 }}>Not used at this level</div>}
            </div>
          </div>

          <div className="option-section-label">Processing Options</div>
          {mode === 'age_estimation' && (
            <>
              <div className="checkbox-row">
                <input type="checkbox" id="adv-skip-linkedin" checked={!!effective('skip_linkedin')} onChange={() => toggle('skip_linkedin')} />
                <label htmlFor="adv-skip-linkedin">Skip LinkedIn scraping</label>
              </div>
              <div className="checkbox-row">
                <input type="checkbox" id="adv-skip-website" checked={!!effective('skip_website')} onChange={() => toggle('skip_website')} />
                <label htmlFor="adv-skip-website">Skip website scraping</label>
              </div>
            </>
          )}
          {mode === 'discovery' && (
            <div className="checkbox-row">
              <input type="checkbox" id="adv-output-validation" checked={!!effective('output_validation')} onChange={() => toggle('output_validation')} />
              <label htmlFor="adv-output-validation">
                Verify top result (photo comparison)
              </label>
            </div>
          )}

        </div>
      )}
    </div>
  );
}
